import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useIsSocketDisconnected = (): IGlobalStore['socket_disconnected'] => {
  return useSelector((store: IReducerStore) => store.global.socket_disconnected);
};
